import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useUpdateIam() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: { name: string; email: string; is_admin: boolean }) => {
      const response = await fetch('/agent/api/iam', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });
      if (!response.ok) {
        throw new Error('Failed to update iam');
      }
      return await response.json();
    },
    onSuccess: () => {
      // IAMデータのキャッシュを無効化して、最新のデータを取得
      queryClient.invalidateQueries({ queryKey: ['iam'] });
    },
  });
}
